/**
 * @generated SignedSource<<ee6c95759412553b6281a3153094e932>>
 * @relayHash 8c25817873956df609af441476ef18a3
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8c25817873956df609af441476ef18a3

import { ConcreteRequest } from 'relay-runtime';
export type setTodoTitleInput = {
  clientMutationId?: string | null | undefined;
  title: string;
  todoId: string;
};
export type TodoMutations_SetTodoTitleMutation$variables = {
  input: setTodoTitleInput;
};
export type TodoMutations_SetTodoTitleMutation$data = {
  readonly setTodoTitle: {
    readonly todo: {
      readonly title: string | null | undefined;
    };
  } | null | undefined;
};
export type TodoMutations_SetTodoTitleMutation = {
  response: TodoMutations_SetTodoTitleMutation$data;
  variables: TodoMutations_SetTodoTitleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoMutations_SetTodoTitleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoTitlePayload",
        "kind": "LinkedField",
        "name": "setTodoTitle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoMutations_SetTodoTitleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "setTodoTitlePayload",
        "kind": "LinkedField",
        "name": "setTodoTitle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8c25817873956df609af441476ef18a3",
    "metadata": {},
    "name": "TodoMutations_SetTodoTitleMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6c10f62bd8010632ff5b745908468695";

export default node;
